import Api from '../../services/Api';

const getStatusList = (idStatusList) => {
    const params = { idStatusPedido: idStatusList },
        url = '/gestao/status-pedido';

    return Api.get(url, { params });
};

const changeStatusPedido = async (idPedido, idStatusPedido) => {
    const body = {
        idStatusPedido
    };
    try {
        const request = await Api.put(
            `/gestao/pedido/${idPedido}/status`,
            body
        );
        const { data = null } = request;
        return data;
    } catch (error) {
        const [e] = error;
        return { errors: e.message };
    }
};

const getPedidoDetalhe = async (idPedido) => {
    const request = await Api.get(`/gestao/pedido/${idPedido}`);
    const response = request.data.data;

    const parsedItens = response.itens.map((item) => {
        if (item.lsProdutoImagem && item.lsProdutoImagem.length) {
            item.lsProdutoImagem = JSON.parse(item.lsProdutoImagem);
        }
        return item;
    });

    response.itens = parsedItens;

    return response;
};

const separarProdutoPedido = async (idPedido, idPedidoProduto, body) => {
    let request = await Api.put(
        `gestao/pedido/${idPedido}/produto/${idPedidoProduto}/separado`,
        body
    );

    return request;
};

const buscarPorCodigoBarras = async (codigoBarras) => {
    let request = await Api.get(`gestao/produto?search=${codigoBarras}`);

    const { data } = request;

    return data;
};

const adicionarProdutoPedido = async (body) => {
    let request = await Api.put(`gestao/pedido`, body);

    return request;
};

const sendPedidoFila = async (body) => {
    let request = await Api.post(`gestao/pedido/fila`, body);

    return request;
};

const imprimirPedido = async (idPedido) => {
    const request = await Api.get(`gestao/pedido/${idPedido}/impressao`, {
        responseType: 'blob'
    });

    return request;
};

const saveVoucher = async (form) => {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };

    const response = await Api.put('gestao/pedido/comprovante', form, config);

    return response;
};

const buscarComprovante = async (idPedido) => {
    return Api.get(`gestao/pedido/${idPedido}/comprovante`, {
        responseType: 'blob'
    })
        .then((data) => {
            return data;
        })
        .catch((error) => {
            return error;
        });
};

export {
    getStatusList,
    changeStatusPedido,
    getPedidoDetalhe,
    separarProdutoPedido,
    buscarPorCodigoBarras,
    adicionarProdutoPedido,
    sendPedidoFila,
    imprimirPedido,
    saveVoucher,
    buscarComprovante
};
